import { RefObject, useEffect } from 'react';
import type Phaser from 'phaser';
import { createGame } from '@/core/bootstrap/createGame';
import { getPlatformAdapter } from '@/platform';
import { useGameStore } from '@/store/gameStore';

type PhaserContainer = HTMLDivElement & {
  __OTAMA_PHASER_GAME__?: Phaser.Game;
};

export function usePhaserGame(containerRef: RefObject<HTMLDivElement | null>) {
  useEffect(() => {
    const container = containerRef.current as PhaserContainer | null;

    if (!container) {
      return;
    }

    const platformAdapter = getPlatformAdapter();

    useGameStore.getState().setPlatformLabel(platformAdapter.label);
    useGameStore.getState().setStatus('Creando runtime Phaser');

    container.__OTAMA_PHASER_GAME__?.destroy(true);
    container.__OTAMA_PHASER_GAME__ = undefined;
    container.replaceChildren();

    const game: Phaser.Game = createGame(container);
    container.__OTAMA_PHASER_GAME__ = game;

    return () => {
      if (container.__OTAMA_PHASER_GAME__ === game) {
        container.__OTAMA_PHASER_GAME__ = undefined;
      }

      game.destroy(true);
      container.replaceChildren();
      useGameStore.getState().setSceneReady(false);
      useGameStore.getState().setStatus('Runtime detenido');
    };
  }, [containerRef]);
}
